<template>
  <CustomDeleteDialog
    :dialogTitle="dialogTitle"
    dialogId="delete-master-from-group-class-confirmation-dialog"
    no-close-on-backdrop
    :isOkDisabled="isOkButtonDisabled"
    @ok="sendDeleteMasterFromGroupClassRequest"
  >
    <BCol cols="12">
      <p>
        آیا از حذف استاد
        <span class="font-weight-bolder">{{ masterFullName }}</span>
        از کلاس
        <span class="font-weight-bolder">{{ groupClassName }}</span>
        اطمینان دارید؟
      </p>
    </BCol>
  </CustomDeleteDialog>
</template>

<script>
export default {
  emits: ["refetch"],
  props: {
    defaultSelectedMaster: {
      type: Object,
    },
  },
  data() {
    return {
      isOkButtonDisabled: false,
    };
  },
  methods: {
    async sendDeleteMasterFromGroupClassRequest() {
      try {
        this.isOkButtonDisabled = true;
        let _this = this;
        let deleteAMasterFromGroupClass = new DeleteAMasterFromGroupClass(
          _this
        );
        deleteAMasterFromGroupClass.setRequestParam({
          id: _this.defaultSelectedMaster.id,
        });
        await deleteAMasterFromGroupClass.fetch((res) => {
          if (res.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "حذف شد!",
                icon: "CheckIcon",
                variant: "success",
                text: "استاد با موفقیت از کلاس گروهی حذف شد.",
              },
            });
            this.$bvModal.hide(
              "delete-master-from-group-class-confirmation-dialog"
            );
            _this.$emit("refetch");
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "حذف نشد!",
                icon: "XIcon",
                variant: "danger",
                text: res.errors || "مشکلی پیش آمد، لطفا دوباره امتحان کنید",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isOkButtonDisabled = false;
      }
    },
  },
  computed: {
    masterFullName() {
      if (this.defaultSelectedMaster) {
        return this.defaultSelectedMaster.masterFullName;
      }
      return "";
    },
    groupClassName() {
      if (this.defaultSelectedMaster) {
        return this.defaultSelectedMaster.groupClassName;
      }
      return "";
    },
    dialogTitle() {
      if (this.defaultSelectedMaster) {
        return `حذف استاد ${this.masterFullName} از کلاس ${this.groupClassName}`;
      }
      return "حذف استاد از کلاس گروهی";
    },
  },
  components: {
    BCol,
    CustomDeleteDialog,
  },
};
import CustomDeleteDialog from "@/views/components/Utils/Dialogs/CustomDeleteDialog.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import { DeleteAMasterFromGroupClass } from "@/libs/Api/GroupClass";
import { BCol } from "bootstrap-vue";
</script>
